export enum Accounts {
  NONE = 'account',
  CHECK = 'account-check',
  EDIT = 'account-edit',
  OFF = 'account-off',
  REMOVE = 'account-remove',
}
